import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { apiGet, apiPost, apiPut } from 'APIPackage/MainModule/common/apiTools';

import { IAdminKnmFormResponse } from '../interfaces/IAdminKnmFormResponse';

export async function fetchKnmFormsAll(): Promise<IAdminKnmFormResponse[]> {
  return apiGet<IAdminKnmFormResponse[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-execution-types/all`,
  );
}

export async function createKnmForm(knmForm: Omit<IAdminKnmFormResponse, 'id'>): Promise<void> {
  return apiPost<void>({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-execution-types`,
    body: knmForm,
  });
}

export async function updateKnmForm(knmForm: IAdminKnmFormResponse): Promise<void> {
  const { id, ...data } = knmForm;

  return apiPut<void>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-execution-types/${id}`, data);
}
